import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { navigationData } from '../mock';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: 'var(--bg-primary)',
        borderBottom: `1px solid ${isScrolled ? 'var(--border-light)' : 'transparent'}`,
        transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
        boxShadow: isScrolled ? '0 2px 8px rgba(0,0,0,0.04)' : 'none'
      }}
    >
      <div className="container" style={{ padding: '20px 40px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <a
            href="#hero"
            onClick={(e) => scrollToSection(e, '#hero')}
            style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none' }}
          >
            <img 
              src={navigationData.logo.image} 
              alt={navigationData.logo.alt} 
              style={{ 
                height: '84px', 
                width: 'auto', 
                objectFit: 'cover',
                objectPosition: 'center center',
                marginTop: '-10px',
                marginBottom: '-10px'
              }} 
            />
          </a>

          <nav style={{ display: 'flex', alignItems: 'center', gap: '32px', listStyle: 'none' }} className="desktop-nav">
            {navigationData.links.map((link, index) => (
              <a key={index} href={link.href} onClick={(e) => scrollToSection(e, link.href)} className="navigation-text" style={{ textDecoration: 'none', position: 'relative', padding: '8px 0', transition: 'color 0.2s ease' }}>{link.text}</a>
            ))}
          </nav>

          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="mobile-menu-toggle" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px', display: 'none' }}>
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <nav className="mobile-nav" style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '24px', paddingTop: '24px', borderTop: '1px solid var(--border-light)' }}>
            {navigationData.links.map((link, index) => (
              <a key={index} href={link.href} onClick={(e) => scrollToSection(e, link.href)} className="navigation-text" style={{ textDecoration: 'none', padding: '8px 0' }}>{link.text}</a>
            ))}
          </nav>
        )}
      </div>

      <style>{`
        @media (max-width: 1024px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-toggle { display: block !important; }
        }
        @media (min-width: 1025px) {
          .mobile-nav { display: none !important; }
        }
      `}</style>
    </header>
  );
};